import { useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import Footer from '../footer'
import Header from '../header'
import ShutdownBanner from '../../common/shutdown-banner'
import styles from './index.module.css'
import cn from 'classnames'
const mainGradient = '/assets/images/main-gradient.svg'
const SharedLayout = ({ children, router }) => {
  const { route } = router
  const page = useRef()

  const noFooter = ['/auth/login', '/auth/register']

  useEffect(() => {
    if (route === '/api-docs') {
      document.body.style.overflowX = 'initial'
      page.current.style.overflow = 'unset'
    } else {
      document.body.style.overflowX = 'hidden'
      page.current.style.overflow = 'hidden'
    }

    // Blog route removed
    page.current.style.backgroundImage = 'none'
  }, [route])

  const renderFooter = () => {
    if (!noFooter.includes(route)) {
      return <Footer router={router} />
    }
  }

  return (
    <div
      ref={page}
      className={cn(
        styles.base,
        'page',
        'animate__animated  animate__fadeIn',
        'min-h-screen flex flex-col',
      )}
    >
      <Header router={router} />
      <ShutdownBanner />
      {children}

      {renderFooter()}
    </div>
  )
}

SharedLayout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default SharedLayout
